module.exports = __webpack_public_path__ + "img/logo.f391f8a9.png";